import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import StatsSummary from '../../../StatsSummary'
import TestCasesAccordionCharts from './TestCasesAccordionCharts'
import { findMostRecentDate } from '../../../../utils/findMostRecentDate'
import { formatDate } from '../../../../utils/formatDate'

const TestCasesAccordion = ({ testCasesData, testCasesTotal }) => {
  const lastGeneratedDate = findMostRecentDate(testCasesData)
  const failedTotal = testCasesData.filter(testCase => testCase.status === "FAILED").length
  const passedTotal = testCasesData.filter(testCase => testCase.status === "COMPLETED").length
  const issueRate = ((failedTotal/testCasesTotal) * 100).toFixed(2)

  return <Box className='testCasesAccordionContainer'>
    <Accordion className='testCasesAccordion' defaultExpanded>
      <AccordionSummary className='testCasesAccordionSummary' expandIcon={<ExpandMoreIcon/>}>
        <Typography className='testCasesAccordionSummaryTitle'>Test Cases</Typography>
      </AccordionSummary>
      <AccordionDetails className='testCasesAccordionDetails'>
        <Box className="testCasesAccordionStatsSection">
          <StatsSummary title="Last Generated Test Cases Date" value={formatDate(lastGeneratedDate)} color="primary" />
          <StatsSummary title="Total Test Cases" value={testCasesTotal} color="primary" />
          <StatsSummary title="Passed Test Cases" value={passedTotal} color="primary" />
          <StatsSummary title="Failed Test Cases" value={failedTotal} color="primary" />
          <StatsSummary title="Issue Rate" value={`${issueRate}%`} color={issueRate > 0 ? "#d32f2f" : "#198754"} />
        </Box>
        <TestCasesAccordionCharts testCasesData={testCasesData}/>
      </AccordionDetails>
    </Accordion>
  </Box>
}

export default TestCasesAccordion